var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 45,
    viewBox: "0 0 34 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 3.60039H3.2V3.80039V41.2004V41.4004H3.4H30.6H30.8V41.2004V14.0004V13.8004H30.6H20.6V3.80039V3.60039H20.4H3.4ZM23.9414 6.03897L23.6 5.69755V6.18039V10.6004V10.8004H23.8H28.22H28.7028L28.3614 10.459L23.9414 6.03897ZM15.5 24.2004V24.0004H15.3H10.6828L17 17.6832L23.3172 24.0004H18.7H18.5V24.2004V32.5004H15.5V24.2004ZM0.2 44.4004V0.600391H22.6972L23.1486 1.05181L33.3486 11.2518L33.8 11.7032V44.4004H0.2ZM23.6 37.6004H10.4V34.6004H23.6V37.6004Z",
    fill: "#73C7A9",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/videoUpload.34a6d6dbbbaa24c91b7435b624a4e971.svg";
export { ForwardRef as ReactComponent };